// @ts-nocheck
import { Dictionary } from "@insite/client-framework/Common/Types";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import FieldDefinition, { ChildFieldDefinition } from "@insite/client-framework/Types/FieldDefinition";
import { TabDefinition } from "@insite/client-framework/Types/TabDefinition";
import { buildResponsiveFields } from "@store/Framework/Common/Fields/FieldDefinitionBuilder/responsiveFields";
import { buildTypographyFields } from "@store/Framework/Common/Fields/FieldDefinitionBuilder/typographyFieldDictionary";
import { PartialBy } from "@store/Framework/Types/Common";
import { FieldDefinitionsBuilderOptions } from "@store/Framework/Types/FieldDefinitionBuilderTypes";
import { FoundationFieldDefinition } from "@store/Framework/Types/FoundationFieldDefinition";
import { breakpointsValues } from "@store/Themes/common/styleguide/config/breakpoints";
import cloneDeep from "lodash/cloneDeep";

type ResponsiveOptionsValuesMapperOptions<TValue = string> = {
    overridedDefaultValuesObj?: HasFields;
    valueToMap?: TValue;
};

export const mapValues = (values: Dictionary<any>, options?: ResponsiveOptionsValuesMapperOptions) => {
    const valuesFields: HasFields = options?.overridedDefaultValuesObj || {
        fields: {},
    };

    for (const key in values) {
        if (Object.prototype.hasOwnProperty.call(values, key)) {
            const element = values[key];
            valuesFields.fields[key] = element;
        }
    }

    return valuesFields;
};

export const getBreakpointFromTitle = (breakpointTitle: string) => Number(breakpointTitle.match(/\d+/g));

const setBreakpointTitle = (breakpoint: number) => `${breakpoint}px`;

export const mapValuesPerBreakpoint = (values: Dictionary<any>, breakpoint: number) => {
    const defaultValuesFields: HasFields = {
        fields: {},
    };

    defaultValuesFields.fields.breakpoint = setBreakpointTitle(breakpoint);

    mapValues(values, {
        overridedDefaultValuesObj: defaultValuesFields,
    });

    return defaultValuesFields;
};

export const getValuesPerBreakpoint = (values: Dictionary<any>) => {
    const breakpoints = [...breakpointsValues];
    breakpoints.shift();

    if (breakpoints?.length) {
        return breakpoints?.map((x: number) => {
            return mapValuesPerBreakpoint(values, x);
        });
    }

    return [];
};

export const fieldDefinitionsToDefaultValuesDictionary = (
    fieldDefinitions: FieldDefinition[] | ChildFieldDefinition[],
) => {
    const values: Dictionary<any> = {};

    for (let index = 0; index < fieldDefinitions.length; index++) {
        const element = fieldDefinitions[index];
        values[element.name] = element.defaultValue;
    }

    return values;
};

export const withTab = (tab: TabDefinition, fieldDefinitions: FoundationFieldDefinition[]) => {
    return cloneDeep(fieldDefinitions).map(x => {
        x.tab = tab;

        return x;
    });
};

export default (
    fieldDefinitions?: FoundationFieldDefinition[],
    options?: FieldDefinitionsBuilderOptions,
): FoundationFieldDefinition[] => {
    const basicTab = {
        displayName: "Basic",
        sortOrder: 0,
    };
    const stylesTab = {
        displayName: "Styles",
        sortOrder: 1,
    };

    const baseFieldDefinitions = [...(fieldDefinitions || [])];

    const childFieldDefinitions: ChildFieldDefinition[] =
        (baseFieldDefinitions as PartialBy<FieldDefinition, "fieldType">[])?.map(x => {
            return x as ChildFieldDefinition;
        }) || [];

    const buildFieldDefinitions = (): FoundationFieldDefinition[] => {
        const fieldDefinitionDraft = baseFieldDefinitions.length
            ? withTab(stylesTab, [...baseFieldDefinitions, ...buildResponsiveFields(childFieldDefinitions)])
            : [];

        const typographyFieldDefinitions = withTab(basicTab, buildTypographyFields(options?.typographyOptions));

        return [...fieldDefinitionDraft, ...typographyFieldDefinitions];
    };

    return buildFieldDefinitions();
};
